import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

import { AppointmentRequest } from '../../models/appointment-request';

@Injectable()
export class AppointmentRequestService {
  private appointmentRequestsURL = 'appointment_requests';

  private mattersURL = 'matters';

  constructor(private httpClient: HttpClientService) {}

  cancelAppointmentRequest(appointmentRequestId: number): Promise<any> {
    return this.httpClient.delete(this.appointmentRequestsURL + '/' + appointmentRequestId + '.json').catch(function () {});
  }

  createAppointmentRequest(data: any): Promise<any> {
    return this.httpClient.post(this.appointmentRequestsURL + '.json', data).catch(function () {});
  }

  getAnnouncements(): Promise<any> {
    return this.httpClient
      .get(this.appointmentRequestsURL + '.json', {
        get_announcements: true,
      })
      .catch(function () {});
  }

  getAppointmentRequest(id: number): Promise<any> {
    return this.httpClient.get(this.appointmentRequestsURL + '/' + id + '.json').catch(function () {});
  }

  getAppointmentRequestResultFormOptions(): Promise<any> {
    return this.httpClient
      .get(this.appointmentRequestsURL + '.json', {
        get_appointment_request_result_form_options: true,
      })
      .catch(function () {});
  }

  getAttendees(matter_id: number): Promise<any> {
    return this.httpClient
      .get(this.mattersURL + '/' + matter_id + '/' + this.appointmentRequestsURL + '.json', {
        get_attendees: true,
      })
      .catch(function () {});
  }

  getEditAppointmentRequest(id: number): Promise<any|void> {
    return this.httpClient.get(this.appointmentRequestsURL + '/' + id + '/edit.json').catch(function () {});
  }

  getFormOptions(): Promise<any> {
    return this.httpClient
      .get(this.appointmentRequestsURL + '.json', {
        get_form_options: true,
      })
      .catch(function () {});
  }

  getSearchOptions(): Promise<any> {
    return this.httpClient
      .get(this.appointmentRequestsURL + '.json', {
        get_search_options: true,
      })
      .catch(function () {});
  }

  search(search_params: any): Promise<any> {
    return this.httpClient.get(this.appointmentRequestsURL + '.json', search_params).catch(function () {});
  }

  updateAppointmentRequest(appointmentRequestId: number, data: any): Promise<any> {
    return this.httpClient.put(this.appointmentRequestsURL + '/' + appointmentRequestId + '.json', data).catch(function () {});
  }
}
